module.exports = __webpack_public_path__ + "img/xl.6625288.jpg";